export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ButtonFavourites.vue?vue&type=template&id=78442f20&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ButtonFavourites.vue?vue&type=template&id=78442f20&
// module id = 10
// module chunks = 0 1 2 3 4 5 6 8